import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
// @mui components
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';

import labelStyle from './labelStyle';

function Label({ ...props }) {
  const {
    classes,
    children,
    className,
    size,
    margin,
    color,
    textfield,
    ...rest
  } = props;

  const labelClasses = clsx({
    [classes.label]: true,
    [classes[color + 'Color']]: color,
    [classes[size + 'Label']]: size,
    [classes[margin + 'Margin']]: margin,
    [classes.textfield]: textfield,
    [className]: className !== undefined
  });
  return (
    <Typography variant="caption" className={labelClasses} {...rest}>
      {children}
    </Typography>
  );
}

Label.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(labelStyle)(Label);
